<template>

	<section class="col-7 margin-b-100 order" v-if="order && product">

		<header class="header margin-b-50 padding-b-50 border-b">

			<h1>Ordre</h1>

			<p>Nedenfor kan du se den valge menu og evt. tilkøb.</p>

		</header>

		<section class="col-12 content margin-b-75 padding-b-75 border-b">

			<section class="col-12 margin-b-100">

				<h1>{{product.title}} ({{order.details.quantity}} stk.) <span dusk="product-price">{{stripeAmount(productPrice).amount}},-</span></h1>

				<template v-for="selection in selectionsFiltered">
					<h2>{{selection.title}}</h2>
					<ul>
                        <template v-for="option in selection.options">
                            <li v-if="option.premium">{{option.title}} ({{order.details.quantity}} stk. á {{stripeAmount(option.price).amount}},-) <span>{{stripeAmount(option.price).amount * order.details.quantity}},-</span></li>
                            <li v-else>{{option.title}}</li>
                        </template>
                        <li v-if="selectionHasPremiumSelected(selection)" class="premium-total">Total <span>{{stripeAmount(selectionSelectedPremiumOptionsTotal(selection)).amount * order.details.quantity}},-</span></li>
					</ul>
				</template>

			</section>

			<section class="col-12 margin-b-100" v-if="extraSelectionsFiltered.length > 0">

				<h1>Tilkøb</h1>

				<template v-for="selection in extraSelectionsFiltered"  v-if="selection.options.length > 0">
					<h2>{{selection.title}}</h2>
					<ul>
						<!--<li v-for="option in selection.options">{{option.title}} ({{order.details.quantity}} stk. á {{stripeAmount(option.price).amount}},-) <a href="#" @click.prevent="removeExtra(option, selection)"><i class="icon&#45;&#45;lg fas fa-times"></i></a></li>-->
                        <li v-for="option in selection.options">{{option.title}} ({{order.details.quantity}} stk. á {{stripeAmount(option.as_extra_price).amount}},-) <span> {{stripeAmount(option.as_extra_price).amount * order.details.quantity}},-</span></li>
                        <li class="premium-total" v-if="selection.options.length > 0">Total  <span>{{stripeAmount(selectionSelectedExtraOptionsTotal(selection)).amount}},-</span></li>
					</ul>
				</template>

			</section>

			<section class="col-12 margin-b-100">

				<h1>Miljø- og emballageafgift <span>{{stripeAmount(packaging).amount}},-</span></h1>

			</section>

            <section class="col-12" v-if="energy_fee !== null">

                <h1>Energiafgift <span>{{stripeAmount(energy).amount}},-</span></h1>
                <p>({{stripeAmount(energy_fee).amount}},- pr. stk)</p>

            </section>

            <section class="col-12 margin-b-100" v-if="order.delivery.with_delivery">

                <h1>Levering <span>{{stripeAmount(order.delivery.delivery_fee).amount}},-</span></h1>

            </section>

			<section class="col-12">

				<h1>Pris</h1>

				<h3>Samlet pris <span dusk="total">{{stripeAmount(total).amount}},-</span></h3>

			</section>

		</section>

		<section class="col-12 flex--space">

			<router-link :to="{name:'make-order.product'}">Tilbage</router-link>

			<a class="btn--primary btn--sm primary--copper" href="#" @click.prevent="goToInformations" dusk="summary-done">Gå til Oplysninger</a>

		</section>
	</section>

</template>

<script>
	import {mapGetters} from 'vuex';
	import totalCalculation from './../mixins/totalCalculation';
    export default {
        name: "order-summary",
		mixins: [totalCalculation],
		computed:{
			...mapGetters({
				order:'order',
				product:'product',
				packaging_fee:'packaging_fee',
                energy_fee:'energy_fee',
			}),
			selectionsFiltered(){
			    return this.product.selections.map(item => {
			       const selected = this.order.details.selections.find(selection => selection.selection_id == item.id);
			       return {
			           title: item.title,
					   options: item.options.filter(option => {
							return selected.options.includes(option.id);
					   }),
				   }
				});
			},
			extraSelectionsFiltered(){
                return this.product.extra_selections.map(item => {
                    const selected = this.order.details.extra_selections.find(selection => selection.extra_selection_id == item.id);
                    if(selected.options.length > 0) {
                        return {
                            id: item.id,
                            title: item.title,
                            options: item.options.filter(option => {
                                return selected.options.includes(option.id);
                            }),
                        }
                    }

                    return null
                }).filter(item => item !== null);
			}
		},
		methods:{
            removeExtra(option, selection){
                this.$store.dispatch('setOptionForExtraSelection', {
                    option,
					selection,
				})
			},
			goToInformations(){
                this.$store.dispatch('completedSummary');
                this.$router.push({name:'make-order.order.information'});
			}

		}
    }
</script>

<style scoped>

</style>
